import { render, staticRenderFns } from "./RegisteredSemiannuallyForm.vue?vue&type=template&id=1b3d573a&scoped=true&"
import script from "./RegisteredSemiannuallyForm.vue?vue&type=script&lang=js&"
export * from "./RegisteredSemiannuallyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d573a",
  null
  
)

export default component.exports